import { Api } from '../api';
import { ICompleteDadosVariaveis, ICreateDadosVariaveis, IListagemDadosVariaveis, IResponseDadosVariaveis } from 'shared/types';


const getAll = async (filter = ''): Promise<IResponseDadosVariaveis | Error> => {
  try {
    const { data, status } = await Api.get(`/DadosVariaveis${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IListagemDadosVariaveis | Error> => {
  try {
    const { data } = await Api.get(`/DadosVariaveis/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (dados: ICreateDadosVariaveis): Promise<string | Error> => {
  try {
    const { data, status } = await Api.post('/DadosVariaveis', dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data.tagDadosVariaveis;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (id: string, dados: ICreateDadosVariaveis,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/DadosVariaveis/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/DadosVariaveis/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const getAutoComplete = async (filter = ''): Promise<ICompleteDadosVariaveis[] | Error> => {
  try {
    const { data, status } = await Api.get(`/DadosVariaveis/autocomplete${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data;
    }
    if (status === 204) {
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const DadosVariaveisService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAutoComplete,
};
